import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Input } from './ui/input';
import { X, Mail, Gift } from 'lucide-react';

const NewsletterPopup = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Handle newsletter subscription
      console.log('Newsletter subscription:', email);
      setIsSubmitted(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md bg-white relative animate-in fade-in-0 zoom-in-95 duration-300">
        <Button 
          variant="ghost" 
          size="sm"
          onClick={onClose}
          className="absolute top-2 right-2 h-8 w-8 p-0"
        >
          <X size={16} />
        </Button>
        
        <CardContent className="p-8 text-center">
          {!isSubmitted ? (
            <>
              <div className="mb-6">
                <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Mail className="text-green-600" size={24} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  Stay in the Loop!
                </h3>
                <p className="text-gray-600">
                  Get exclusive deals, new strain alerts, and insider access to Big Dog Kush drops.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Input
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 text-center"
                    required
                  />
                </div>
                
                <Button 
                  type="submit"
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3"
                >
                  Get Exclusive Access
                </Button>
              </form>

              <div className="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <div className="flex items-center justify-center gap-2 text-yellow-700 mb-2">
                  <Gift size={16} />
                  <span className="font-semibold">Bonus Offer!</span>
                </div>
                <p className="text-sm text-yellow-700">
                  Get 15% off your next order when you subscribe
                </p>
              </div>

              <p className="text-xs text-gray-500 mt-4">
                We respect your privacy. Unsubscribe at any time.
              </p>
            </>
          ) : (
            <div className="py-4">
              <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                <div className="text-green-600 text-2xl">✓</div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Welcome to the Pack! 🐕
              </h3>
              <p className="text-gray-600">
                Thanks for subscribing! Check your email for your 15% off code.
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NewsletterPopup;